import { useState } from 'react';
import { TradeMode } from '@shared/types/frontend/trade';
import { useSwap } from '@/contexts/SwapProvider';
import SwapTabMobile from './SwapTabMobile';
import SwapFromAssetSelectModal from '@/components/trade/mobile/SwapFromAssetSelectModal';
import SwapToAssetSelectModal from '@/components/trade/mobile/SwapToAssetSelectModal';
import BuySellAssetSelectModal from '@/components/trade/mobile/BuySellAssetSelectModal';
import SwapSettings from '@/components/trade/mobile/SwapSettings';
interface Props {
  onClose: () => void;
  tradeMode: TradeMode;
}
export default function SwapHomeMobile(p: Props) {
  const {
    selectFromAsset,
    setSelectFromAsset,
    selectToAsset,
    setSelectToAsset,
    fromAssets,
    setFromAssets,
    toAssets,
    setToAssets
  } = useSwap();
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  return <div className='w-full flex items-center overflow-y-auto pt-4' data-sentry-component="SwapHomeMobile" data-sentry-source-file="SwapHomeMobile.tsx">
      <SwapTabMobile onClose={p.onClose} tradeMode={p.tradeMode} setSettingsModalOpen={setSettingsModalOpen} data-sentry-element="SwapTabMobile" data-sentry-source-file="SwapHomeMobile.tsx" />

      {/* Modals */}

      <SwapSettings isModalOpen={isSettingsModalOpen} onClose={() => setSettingsModalOpen(false)} data-sentry-element="SwapSettings" data-sentry-source-file="SwapHomeMobile.tsx" />

      {p.tradeMode === TradeMode.BUY || p.tradeMode === TradeMode.SELL ? <BuySellAssetSelectModal isOpen={selectFromAsset || selectToAsset} onClose={() => {
      setSelectFromAsset(false);
      setSelectToAsset(false);
    }} tradeMode={p.tradeMode} setAsset={p.tradeMode === TradeMode.BUY ? setFromAssets : setToAssets} tradedAsset={p.tradeMode === TradeMode.BUY ? toAssets[0] : fromAssets[0]} /> : null}

      {p.tradeMode === TradeMode.SWAP ? <>
          <SwapFromAssetSelectModal isOpen={selectFromAsset} onClose={() => setSelectFromAsset(false)} setFromAssets={setFromAssets} fromAssets={fromAssets} />

          <SwapToAssetSelectModal isOpen={selectToAsset} onClose={() => setSelectToAsset(false)} setToAssets={setToAssets} selectToAsset={selectToAsset} toAssets={toAssets} setSelectToAsset={setSelectToAsset} />
        </> : null}
    </div>;
}